import { Provider } from '@angular/core';
import { featureManagementProviders } from './modules/feature-management/feature-management';

// The file containing modules and providers that have to be added to platform module
// when build configuration is "development"

export const overrideModules = [];
export const overrideProviders: Provider[] = [...featureManagementProviders];
